import { PayPalMessages } from '@paypal/react-paypal-js';
import React, { useState } from 'react';

const getIsEligibleFromLander = (url: string | URL): boolean => {
  const urlObj = new URL(url);
  const params = urlObj.searchParams;
  const min = parseFloat(params.get('min') || 'Infinity');
  const max = parseFloat(params.get('max') || 'Infinity');
  const amount = parseFloat(params.get('amount') || 'Infinity');

  return amount >= min && amount <= max;
};

interface IPaypalPayLaterMessageProps {
  amount?: number;
}

const PaypalPayLaterMessage: React.FC<IPaypalPayLaterMessageProps> = ({
  amount,
}) => {
  const [isEligible, setIsEligible] = useState(false);

  const handleRender = (props) => {
    setIsEligible(getIsEligibleFromLander(props?.meta.lander));
  };

  if (!amount) return null;

  return (
    <>
      <PayPalMessages
        forceReRender={[amount]}
        onRender={handleRender}
        amount={amount}
        placement="cart"
        className="paypal-messages-pay-later"
        style={{
          text: { align: 'center', size: 15 },
          logo: { position: 'top' },
        }}
      />
      <style jsx>{`
        :global(.paypal-messages-pay-later) {
          visibility: ${isEligible ? 'visible' : 'hidden'};
          height: ${isEligible ? 'inherit' : '0'};
          margin: var(--space-3);
        }
      `}</style>
    </>
  );
};

export default PaypalPayLaterMessage;
